import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import reportWebVitals from './reportWebVitals'
import { beforeSend, getCurrentTenantFromPath, getSentryOptions } from './utils/sentryConfig'

// Initialize Sentry as early as possible
const sentryOptions = getSentryOptions()
if (sentryOptions.enabled) {
  Sentry.init({
    dsn: sentryOptions.dsn,
    environment: sentryOptions.environment,
    release: sentryOptions.release,
    sendDefaultPii: sentryOptions.sendDefaultPii,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: sentryOptions.tracesSampleRate,
    replaysSessionSampleRate: sentryOptions.replaysSessionSampleRate,
    replaysOnErrorSampleRate: sentryOptions.replaysOnErrorSampleRate,
    initialScope: {
      tags: {
        tenant_url: getCurrentTenantFromPath(),
      },
    },
    beforeSend,
  })
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
